/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import HeroBanner from "../../../reusable-components/hero_banners/HeroBanner";
import H1 from "../../../reusable-components/headings/H1";
import { useForm } from "react-hook-form";
import Input from "../../../reusable-components/inputs/InputTextBox/Input";
import Captcha from "../../../utilities/captcah/Captcha";
import Button from "../../../reusable-components/buttons/Button";
import SubmitButton from "../../../reusable-components/buttons/SubmitButton";
import showToast from "../../../utilities/notification/NotificationModal";
import DigitalSignature from "../../../assets/DigitalSignature.png";
import { FiCreditCard, FiSearch } from "react-icons/fi";
import {
  FEEDBACK_URL,
  PUBLIC_NOC_APPLICATION,
} from "../../../api/api_routing_urls";
import axios from "../../../api/axios";
import {
  button,
  disabled_button,
  linkTextPrimary,
} from "../../../theme/lightTheme";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import { formatINRCurrency } from "../../../utilities/currency/currency";
import sabccoLogo from "../../../assets/SABCCO_128x128.png";
import { getFormattedDateDDMMYYYY } from "../../../utilities/dateFunctions/formatdate";
import { PrintNOCApplication } from "../../system-admin/ReportsList/PrintReport/PrintNOCApplication";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";

// import QRCode from "qrcode";
import { dataURLtoFile } from "../../../utilities/fileFunctions/imageFunctions";

import QRCode from "react-qr-code";

const ViewNOCApplication = () => {
  const navigate = useNavigate();
  const controller = new AbortController();
  const [viewApplicationDetail, setViewApplicationDetail] = useState(false);

  const [nocApplicationDetail, setnocApplicationDetail] = useState();
  const [nocApplicantPaymentDetail, setNocApplicantPaymentDetail] = useState();

  const [qrCodeUrl, setQRCodeUrl] = useState(null);

  const { uniqueSerialNumber } = useParams();

  const getNocApplicationDetail = async () => {
    try {
      let response = await axios.get(
        `${PUBLIC_NOC_APPLICATION}/get`,
        { params: { noc_serial_no: uniqueSerialNumber } },
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200 && response?.data?.nocApplication) {
        setnocApplicationDetail(response?.data?.nocApplication);
        setViewApplicationDetail(true);

        window.scroll({ top: 100 });
      } else {
      }
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  const getNocApplicantPaymentDetail = async () => {
    try {
      let response = await axios.get(
        `${PUBLIC_NOC_APPLICATION}/getPaymentDetailsWithSerialNo`,
        { params: { noc_serial_no: uniqueSerialNumber } },
        {
          signal: controller.signal,
        },
      );

      if (response?.status === 200 && response?.data?.nocApplication) {
        setNocApplicantPaymentDetail(
          response?.data?.nocApplication
            ?.get_payment_transaction_details_by_serial_no[0]?.txn_json_data,
        );

        window.scroll({ top: 100 });
      } else {
      }
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error",
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (uniqueSerialNumber && isMounted) {
      getNocApplicationDetail();
      getNocApplicantPaymentDetail();
    }

    return () => {
      isMounted = false;
    };
  }, [uniqueSerialNumber]);

  useEffect(() => {
    if (!uniqueSerialNumber) {
      console.error("Unique serial number is not provided");
      return;
    }

    const textToEncode = `https://sikkimsabcco.com/view-noc-application/${uniqueSerialNumber}`;
    setQRCodeUrl(textToEncode); // Set the QR code URL
  }, [uniqueSerialNumber]);

  return (
    <>
      <HeroBanner>
        <div className="absolute left-10 md:left-14 lg:left-1/5 right-10 md:right-14 lg:right-10 top-1/2">
          <div className="text-center">
            <H1>No Objection Certificate Application</H1>
          </div>
        </div>
      </HeroBanner>
      {viewApplicationDetail ? (
        <>
          <section className="container mx-auto max-w-7xl my-9 px-3">
            {/* <p
              className={`text-center text-sm font-semibold p-3 my-6 border rounded-sm
            ${
              nocApplicationDetail?.isverified &&
              !nocApplicationDetail?.isloanee
                ? " border-green-800  text-green-900 bg-green-100"
                : " border-yellow-800  text-yellow-900  bg-yellow-100"
            }
            `}
            >
              This application has
              {nocApplicationDetail?.isverified &&
              !nocApplicationDetail?.isloanee ? (
                " been verified. You may print/download your application."
              ) : (
                <>
                  {nocApplicantPaymentDetail?.auth_status === "0399" && (
                    <>
                      &nbsp;been declined due to an outstanding payment issue.
                      Please complete the payment to proceed.{" "}
                    </>
                  )}
                  {nocApplicantPaymentDetail?.auth_status === "0300" && (
                    <>
                      &nbsp;been sent for verification after successful payment.
                      Please wait for the verification process to complete.
                    </>
                  )}
                  {nocApplicantPaymentDetail?.auth_status === "0002" && (
                    <>
                      &nbsp;has been put on hold due to a pending payment. Once
                      the payment is successful, your application will be sent
                      for verification.
                    </>
                  )}

                  {nocApplicationDetail?.isloanee ? (
                    <>
                      &nbsp;cannot be processed because the applicant has an
                      active loan. An NOC can only be issued after the loan is
                      fully closed and all outstanding obligations are cleared.
                    </>
                  ) : (
                    <>
                      &nbsp;cannot be processed because there are outstanding
                      dues on the applicant's account. Kindly clear the pending
                      dues to proceed. Once the payment is received and
                      verified, the application will be processed further.
                    </>
                  )}
                </>
              )}
            </p> */}

            <div className="mb-3 rounded-xl border border-slate-200 bg-white shadow-sm">
              <div className="border-b border-slate-200 px-4 py-3">
                <h3 className="text-base font-semibold text-slate-800">
                  Application Progress
                </h3>

                <p className="mt-0.5 text-xs text-slate-500">
                  Current processing status of this application.
                </p>
              </div>

              <div className="p-4">
                <div className="flex flex-col gap-3 md:flex-row md:items-center">
                  {/* Submitted */}
                  <div className="flex flex-1 items-center gap-2">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-500 text-sm font-semibold text-white">
                      ✓
                    </div>

                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-800">
                        Submitted
                      </p>
                      <p className="text-xs leading-4 text-slate-500">
                        Application received
                      </p>
                    </div>
                  </div>

                  <div className="hidden h-px flex-1 bg-slate-200 md:block" />

                  {/* Payment */}
                  <div className="flex flex-1 items-center gap-2">
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                        nocApplicationDetail?.is_convenience_fee_paid
                          ? "bg-green-500"
                          : "bg-amber-500"
                      }`}
                    >
                      {nocApplicationDetail?.is_convenience_fee_paid
                        ? "✓"
                        : "2"}
                    </div>

                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-800">
                        Payment
                      </p>

                      <p className="text-xs leading-4 text-slate-500">
                        {nocApplicationDetail?.is_convenience_fee_paid
                          ? "Payment recorded"
                          : "Awaiting payment"}
                      </p>
                    </div>
                  </div>

                  <div className="hidden h-px flex-1 bg-slate-200 md:block" />

                  {/* Verification */}
                  <div className="flex flex-1 items-center gap-2">
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                        nocApplicationDetail?.isverified
                          ? "bg-green-500"
                          : nocApplicationDetail?.is_convenience_fee_paid
                            ? "bg-blue-500"
                            : "bg-slate-300"
                      }`}
                    >
                      {nocApplicationDetail?.isverified ? "✓" : "3"}
                    </div>

                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-800">
                        Verification
                      </p>

                      <p className="text-xs leading-4 text-slate-500">
                        {nocApplicationDetail?.isverified
                          ? "Completed"
                          : nocApplicationDetail?.is_convenience_fee_paid
                            ? "Ready for verification"
                            : "Waiting for payment"}
                      </p>
                    </div>
                  </div>

                  <div className="hidden h-px flex-1 bg-slate-200 md:block" />

                  {/* Decision */}
                  <div className="flex flex-1 items-center gap-2">
                    <div
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${
                        nocApplicationDetail?.isverified
                          ? nocApplicationDetail?.isloanee
                            ? "bg-red-500"
                            : "bg-green-500"
                          : "bg-slate-300"
                      }`}
                    >
                      {nocApplicationDetail?.isverified ? "✓" : "4"}
                    </div>

                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-800">
                        Decision
                      </p>

                      <p className="text-xs leading-4 text-slate-500">
                        {nocApplicationDetail?.isverified
                          ? nocApplicationDetail?.isloanee
                            ? "Rejected"
                            : "Approved"
                          : "Pending"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p
              className={`text-center text-sm font-semibold p-3 my-6 border rounded-sm ${
                nocApplicationDetail?.isverified &&
                !nocApplicationDetail?.isloanee
                  ? "border-green-800 text-green-900 bg-green-100"
                  : "border-yellow-800 text-yellow-900 bg-yellow-100"
              }`}
            >
              {nocApplicationDetail?.isverified &&
              !nocApplicationDetail?.isloanee &&
              nocApplicationDetail?.is_convenience_fee_paid
                ? "This application has been verified. You may print or download your NOC Application."
                : nocApplicationDetail?.isloanee
                  ? "This application cannot be processed because the applicant has an active loan. An NOC can only be issued after the loan has been fully closed and all outstanding obligations have been cleared."
                  : nocApplicantPaymentDetail?.auth_status === "0399"
                    ? "This application has been put on hold due to a payment failure. Please complete the payment to proceed."
                    : nocApplicantPaymentDetail?.auth_status === "0300"
                      ? "Payment has been received successfully. Your application has been sent for verification. Please wait while the verification process is completed."
                      : nocApplicantPaymentDetail?.auth_status === "0002" ||
                          !nocApplicationDetail?.is_convenience_fee_paid
                        ? "Payment is pending. Once the payment is completed successfully, your application will be sent for verification OR if already verified You may print or download your NOC Application."
                        : "This application cannot be processed because there are outstanding dues on the applicant's account. Please clear all pending dues to proceed. Once the payment is received and verified, your application will be processed further."}
            </p>

            {nocApplicationDetail?.is_convenience_fee_paid ? (
              <></>
            ) : (
              <>
                {/* Payment Options */}
                <div className="mt-8 grid gap-6 md:grid-cols-2">
                  {/* Online Payment */}
                  <div className="rounded-lg border border-green-200 bg-green-50 p-6">
                    <h6 className="text-lg font-semibold text-green-800">
                      💳 Online Payment
                    </h6>

                    <p className="mt-2 text-sm text-green-700">
                      Pay securely online using the payment gateway.
                    </p>

                    <div className="mt-5 flex flex-col gap-3">
                      <Button
                        className="flex w-full items-center justify-center rounded-lg bg-primary px-6 py-3.5 text-base font-semibold text-white shadow-sm 
                        transition-all duration-200 hover:bg-primary/90 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/30"
                        onClick={() =>
                          navigate("/noc-applicant-login", {
                            state: { uniqueSerialNumber },
                          })
                        }
                      >
                        <FiCreditCard className="mr-2 h-5 w-5" />
                        Make Payment
                      </Button>

                      <Button
                        className="flex w-full items-center justify-center rounded-lg border border-primary bg-white px-6 py-3.5 text-base font-semibold
                           text-primary shadow-sm transition-all duration-200 hover:bg-primary hover:text-white hover:shadow-lg 
                           focus:outline-none focus:ring-2 focus:ring-primary/30"
                        onClick={() => navigate("/noc-applicant-login")}
                      >
                        <FiSearch className="mr-2 h-5 w-5" />
                        Check Payment Status
                      </Button>
                    </div>
                  </div>

                  {/* Offline Payment */}
                  <div className="rounded-lg border border-amber-200 bg-amber-50 p-6">
                    <h6 className="text-lg font-semibold text-amber-900">
                      🏢 Pay at Office (Cash)
                    </h6>

                    <p className="mt-2 text-sm text-amber-800">
                      If you prefer, you may visit our office and make the
                      payment in cash.
                    </p>

                    <div className="mt-4 rounded-md bg-white p-4 text-sm leading-6 text-gray-700">
                      <p className="font-semibold">
                        Sikkim SC, ST and OBC Development Corporation Ltd.
                      </p>
                      <p>Chuten Road, Deorali</p>
                      <p>Gangtok, Sikkim – 737102</p>
                    </div>
                  </div>
                </div>
              </>
            )}

            <h6 className="text-lg font-semibold text-center text-slate-800 mt-9 mb-3">
              Preview of the NOC application
            </h6>

            <div className="bg-white py-9 border">
              <NOCApplicationForm
                nocApplicationDetail={nocApplicationDetail}
                qrCode_Url={qrCodeUrl} // Pass QR Code URL to child
                uniqueSerialNumber={uniqueSerialNumber} // Pass uniqueSerialNumber to child
              />
            </div>
            <div className=" md:flex justify-between items-center mt-9">
              <Button onClick={() => navigate("/noc-application")}>
                <p className={` texMaket-center ${linkTextPrimary} mb-9`}>
                  Return to NOC Application
                </p>
              </Button>
              {nocApplicationDetail?.isverified &&
              !nocApplicationDetail?.isloanee &&
              nocApplicationDetail?.is_convenience_fee_paid ? (
                <>
                  <PrintNOCApplication>
                    <NOCApplicationForm
                      nocApplicationDetail={nocApplicationDetail}
                      qrCode_Url={qrCodeUrl}
                      uniqueSerialNumber={uniqueSerialNumber}
                    />
                  </PrintNOCApplication>
                </>
              ) : null}
            </div>
          </section>{" "}
        </>
      ) : (
        <section>
          <div className="container mx-auto max-w-7xl my-9">
            <div className="border text-center bg-yellow-100 p-9">
              <p className="bg-white text-2xl p-3 my-6 border border-yellow-800 rounded-sm text-yellow-900 flex-col flex items-center justify-center">
                <MdOutlineDoNotDisturbAlt size={56} />
                <p>
                  NOC Application with Serial No:
                  <span className="font-bold"> {uniqueSerialNumber} </span>
                  not found.
                </p>
              </p>{" "}
              <div className=" text-white mt-[3rem] cursor-pointer">
                <NavLink end to="/noc-application">
                  <Button className={button}>
                    <span className="">Check another NOC Application</span>
                  </Button>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ViewNOCApplication;

const NOCApplicationForm = ({
  nocApplicationDetail,
  qrCode_Url,
  uniqueSerialNumber,
}) => {
  const [qrCodeUrl, setQRCodeUrl] = useState(null);
  const [qrCodeUrlStatus, setQRCodeUrlStatus] = useState(false);

  const is_parcha =
    nocApplicationDetail?.noc_purpose === "REGISTRATION/MUTATION" ||
    nocApplicationDetail?.noc_purpose === "PARCHA" ||
    nocApplicationDetail?.noc_purpose === "registration/property mutation" ||
    nocApplicationDetail?.noc_purpose === "lost of Parcha";

  useEffect(() => {
    if (uniqueSerialNumber) {
      const textToEncode = `https://sikkimsabcco.com/view-noc-application/${uniqueSerialNumber}`;
      setQRCodeUrl(textToEncode);

      setQRCodeUrlStatus(true);
    }
  }, [uniqueSerialNumber]);

  return (
    <>
      <div className="noc-content w-full bg-white px-6 text-[13px] leading-relaxed text-justify">
        <div className="w-full">
          <div className="noc-header flex w-full items-center justify-between gap-4 py-3">
            <div className="flex gap-3 items-center my-6 ">
              <img
                className="noc-logo h-16 w-16 shrink-0 object-contain"
                src={sabccoLogo}
              />
              <div>
                <p className="noc-title text-center text-[15px] font-semibold leading-tight">
                  Sikkim SC / ST / OBC Development Corporation.Ltd. (SABCCO)
                </p>
                <p className="noc-address mt-1 text-[12px] leading-tight">
                  Chorten Monastery Road, Deorali, Gangtok, Sikkim - 737102
                </p>
              </div>
            </div>
            <div>
              {/* <p className="text-center text-xs"> QR Code:</p> */}
              {qrCodeUrl || qrCodeUrlStatus ? (
                <div className="noc-qr flex h-24 w-24 shrink-0 items-center justify-end">
                  <QRCode
                    size={20}
                    style={{
                      height: "auto",
                      width: "90%",
                    }}
                    value={`${qrCodeUrl}`}
                  />
                </div>
              ) : (
                <p>Loadig QR Code ...</p>
              )}
            </div>
          </div>
        </div>

        <div className="noc-meta flex items-center justify-between border-y border-gray-200 py-2 text-[12px]">
          {nocApplicationDetail.noc_serial_no ? (
            <>
              <p className="font-semibold">
                Serial No.: {nocApplicationDetail.noc_serial_no}
              </p>
            </>
          ) : null}

          {nocApplicationDetail.createdat ? (
            <>
              <p className="font-semibold">
                Date: {getFormattedDateDDMMYYYY(nocApplicationDetail.createdat)}
              </p>
            </>
          ) : null}
        </div>

        <p className="text-center text-[12px] font-semibold text-yellow-600">
          {nocApplicationDetail?.isverified ? "" : "Unverified"}
        </p>

        <div className="mb-9">
          <p className="noc-heading mb-4 text-center text-[14px] font-bold tracking-wide">
            TO WHOM IT MAY CONCERN
          </p>

          <p className="noc-paragraph leading-[1.45]">
            This is to certify that Shri/Smt/Kumari
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_name}{" "}
            </span>
            , S/o, D/o, W/o
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_relative_name}{" "}
            </span>
            , resident of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_resident}{" "}
            </span>
            , does not have any outstanding loan or other dues as reflected in
            the books of this Corporation. Hence, this Corporation has no
            objection to the applicant obtaining this No Objection Certificate
            for the purpose of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_purpose}{" "}
            </span>
            {nocApplicationDetail?.noc_department_name && (
              <>
                {" "}
                in{" "}
                <span className="font-semibold">
                  {nocApplicationDetail?.noc_department_name}
                </span>
                {String(nocApplicationDetail?.noc_department_name).includes(
                  "Department",
                ) ||
                String(nocApplicationDetail?.noc_department_name).includes(
                  "Dept.",
                )
                  ? null
                  : " Department"}
              </>
            )}
            .
          </p>

          {is_parcha ? (
            <p className="noc-paragraph pt-2 leading-[1.45]">
              Percha/Land Title bearing Khatian No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khatian_no}{" "}
              </span>{" "}
              Khasra No./Plot No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khasra_no}{" "}
              </span>{" "}
              and Area of{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_area}{" "}
              </span>{" "}
              Hectares registered in the name{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.parcha_holder_name}{" "}
              </span>{" "}
              situated at{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_situated}{" "}
              </span>
            </p>
          ) : null}

          <p className="noc-paragraph pt-2 leading-[1.45]">
            This certificate is issued without prejudice to the Corporation's
            right to recover the loan amount if it is found at any later point
            of time that he/she owes any amount to this Corporation.
          </p>

          <p className="noc-paragraph pt-2 leading-[1.45]">
            This certificate is valid for a period of 6 (Six) months from the
            date of issue.
          </p>
        </div>

        <div className="noc-signature mt-8 flex items-end justify-between">
          <div>
            <p className="">Prepared and checked by ........................</p>
            <p className="font-semibold pt-6">{formatINRCurrency(150)}/-</p>
          </div>

          {nocApplicationDetail?.isverified &&
          !nocApplicationDetail?.isloanee &&
          nocApplicationDetail?.is_convenience_fee_paid ? (
            <>
              <div>
                {/* <img
                  src={DigitalSignature}
                  className="w-[12rem] h-auto object-cover"
                  alt="Digital signature"
                /> */}

                {/* <p className="mt-16">Asstt. Manager/Manager/Dy.G.M</p> */}
                <div className="text-center">
                  <p className="font-medium">General Manager</p>
                </div>
              </div>
            </>
          ) : (
            <div className="mt-8 text-center">
              <p>General Manager</p>
            </div>
          )}
        </div>
      </div>

      {/* <div className=" text-[14px] px-9 text-justify bg-white">
        <div className="w-full">
          <div className="flex justify-between gap-3 items-center my-6 mx-auto w-full">
            <div className="flex gap-3 items-center my-6 ">
              <img className="h-16 w-16" src={sabccoLogo} />
              <div>
                <p className="text-center text-[16px] font-semibold">
                  Sikkim SC / ST / OBC Development Corporation.Ltd. (SABCCO)
                </p>
                <p className="text-[14px]  -mt-1">
                  Chorten Monastery Road, Deorali, Gangtok, Sikkim - 737102
                </p>
              </div>
            </div>
            <div>
             
              {qrCodeUrl || qrCodeUrlStatus ? (
                <div className="flex items-center w-48 justify-end ">
                  <QRCode
                    size={3}
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "50%",
                    }}
                    value={`${qrCodeUrl}`}
                  />
                </div>
              ) : (
                <p>Loadig QR Code ...</p>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          {nocApplicationDetail.noc_serial_no ? (
            <>
              <p className="font-semibold">
                Serial No.: {nocApplicationDetail.noc_serial_no}
              </p>
            </>
          ) : null}

          {nocApplicationDetail.createdat ? (
            <>
              <p className="font-semibold">
                Date: {getFormattedDateDDMMYYYY(nocApplicationDetail.createdat)}
              </p>
            </>
          ) : null}
        </div>

        <p className="text-center text-[16px] font-semibold text-yellow-600">
          {nocApplicationDetail?.isverified ? "" : "Unverified"}
        </p>

        <div className="mb-9">
          <p className="font-semibold text-center mb-6">
            TO WHOM IT MAY CONCERN
          </p>

          <p>
            This is to certify that Shri/Smt/Kumari
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_name}{" "}
            </span>
            , S/o, D/o, W/o
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_relative_name}{" "}
            </span>
            , resident of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_resident}{" "}
            </span>
            , does not have any outstanding loan or other dues as reflected in
            the books of this Corporation. Hence, this Corporation has no
            objection to the applicant obtaining this No Objection Certificate
            for the purpose of
            <span className="font-semibold">
              {" "}
              {nocApplicationDetail?.noc_purpose}{" "}
            </span>
            {nocApplicationDetail?.noc_department_name && (
              <>
                {" "}
                in{" "}
                <span className="font-semibold">
                  {nocApplicationDetail?.noc_department_name}
                </span>
                {String(nocApplicationDetail?.noc_department_name).includes(
                  "Department",
                ) ||
                String(nocApplicationDetail?.noc_department_name).includes(
                  "Dept.",
                )
                  ? null
                  : " Department"}
              </>
            )}
            .
          </p>

          {is_parcha ? (
            <p className="pt-3">
              Percha/Land Title bearing Khatian No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khatian_no}{" "}
              </span>{" "}
              Khasra No./Plot No{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.khasra_no}{" "}
              </span>{" "}
              and Area of{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_area}{" "}
              </span>{" "}
              Hectares registered in the name{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.parcha_holder_name}{" "}
              </span>{" "}
              situated at{" "}
              <span className="font-semibold">
                {" "}
                {nocApplicationDetail?.noc_situated}{" "}
              </span>
            </p>
          ) : null}

          <p className="pt-3">
            This certificate is issued without prejudice to the Corporation's
            right to recover the loan amount if it is found at any later point
            of time that he/she owes any amount to this Corporation.
          </p>

          <p className="pt-3">
            This certificate is valid for a period of 6 (Six) months from the
            date of issue.
          </p>
        </div>

        <div className="flex flex-row justify-between">
          <p className="font-semibold">{formatINRCurrency(150)}/-</p>

          {nocApplicationDetail?.isverified &&
          !nocApplicationDetail?.isloanee &&
          nocApplicationDetail?.is_convenience_fee_paid ? (
            <>
              <div>
                {/* <img
                  src={DigitalSignature}
                  className="w-[12rem] h-auto object-cover"
                  alt="Digital signature"
                /> 

              
                <p className="text-center">General Manager</p>
              </div>
            </>
          ) : (
            <div className="mt-16">
              <p className="text-center ">General Manager</p>
            </div>
          )}
        </div>
      </div> */}
    </>
  );
};
